import React, { useState, useEffect } from 'react';
import { rentabilidad } from '../utils/api';
import toast from 'react-hot-toast';

const fmt = (n) => new Intl.NumberFormat('es-CO', { style:'currency', currency:'COP', maximumFractionDigits:0 }).format(n || 0);
const f = { fontFamily:"'Plus Jakarta Sans',sans-serif" };

export default function RentabilidadPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [days, setDays] = useState(30);
  const [tab, setTab] = useState('winners');

  useEffect(() => { loadData(); }, [days]);

  const loadData = async () => {
    setLoading(true);
    try { const res = await rentabilidad.porPublicacion(days); setData(res.data); }
    catch (err) { toast.error('Error cargando rentabilidad'); }
    finally { setLoading(false); }
  };

  const filtered = data?.publicaciones?.filter(p => {
    if (tab === 'winners') return p.diagnostico === 'Killer';
    if (tab === 'criticos') return p.diagnostico === 'Crítico';
    if (tab === 'oportunidades') return p.diagnostico === 'Estable';
    return true;
  }) || [];

  const diagColor = (d) => {
    if (d === 'Killer') return { bg:'#e8f9d4', color:'#3d7a00' };
    if (d === 'Crítico') return { bg:'#fee2e2', color:'#dc2626' };
    return { bg:'#fff7ed', color:'#f97316' };
  };

  const diagLabel = (d) => d === 'Killer' ? 'Winner' : d;

  return (
    <div style={{ ...f, padding:'24px 28px', background:'#f5f5ef', minHeight:'100vh' }}>

      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:24 }}>
        <div>
          <h1 style={{ fontSize:24, fontWeight:800, color:'#1a1a1a', letterSpacing:'-0.5px', margin:0 }}>Rentabilidad por Publicación</h1>
          <p style={{ fontSize:13, color:'#aaa', marginTop:4 }}>Margen de contribución · Meta: +30%</p>
        </div>
        <div style={{ display:'flex', gap:4, background:'#fff', border:'1px solid #e8e8e0', borderRadius:20, padding:4 }}>
          {[7,15,30].map(d => (
            <button key={d} onClick={() => setDays(d)}
              style={{ padding:'5px 14px', borderRadius:16, fontSize:11, fontWeight:700, border:'none', cursor:'pointer', fontFamily:'Plus Jakarta Sans,sans-serif',
                background: days===d ? '#1a1a1a' : 'transparent',
                color: days===d ? '#fff' : '#888' }}>
              {d}D
            </button>
          ))}
        </div>
      </div>

      {data && (
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12, marginBottom:20 }}>
          <div style={{ background:'#fff', border:'1px solid #e8e8e0', borderRadius:18, padding:20 }}>
            <div style={{ fontSize:11, fontWeight:700, color:'#aaa', textTransform:'uppercase', letterSpacing:'.5px', marginBottom:8 }}>Margen total</div>
            <div style={{ fontSize:26, fontWeight:800, color:'#7c5ef8', letterSpacing:'-1px' }}>{fmt(data.resumen?.margen_total)}</div>
          </div>
          <div style={{ background:'#fff', border:'1px solid #e8e8e0', borderRadius:18, padding:20 }}>
            <div style={{ fontSize:12, color:'#aaa', fontWeight:600, marginBottom:14 }}>Salud del portafolio</div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:8 }}>
              {[['WINNERS', data.resumen?.killers, '#3d7a00', '#e8f9d4'],
                ['REGULARES', data.resumen?.regulares, '#f97316', '#fff7ed'],
                ['CRÍTICOS', data.resumen?.criticos, '#dc2626', '#fee2e2']].map(([l,v,color,bg]) => (
                <div key={l} style={{ background:bg, borderRadius:10, padding:'10px', textAlign:'center' }}>
                  <div style={{ fontSize:9, fontWeight:700, color, letterSpacing:'.5px' }}>{l}</div>
                  <div style={{ fontSize:22, fontWeight:800, color, marginTop:4 }}>{v || 0}</div>
                </div>
              ))}
            </div>
          </div>
          <div style={{ background:'#fff', border:'1px solid #e8e8e0', borderRadius:18, padding:20 }}>
            <div style={{ fontSize:11, fontWeight:700, color:'#aaa', textTransform:'uppercase', letterSpacing:'.5px', marginBottom:8 }}>Total publicaciones</div>
            <div style={{ fontSize:26, fontWeight:800, color:'#1a1a1a', letterSpacing:'-1px' }}>{data.publicaciones?.length || 0}</div>
            <div style={{ fontSize:11, color:'#bbb', marginTop:4 }}>analizadas en el periodo</div>
          </div>
        </div>
      )}

      <div style={{ display:'flex', gap:4, background:'#fff', border:'1px solid #e8e8e0', borderRadius:16, padding:4, marginBottom:16, width:'fit-content' }}>
        {[['winners','🏆 Top Winners'],['criticos','⚠️ Críticos'],['oportunidades','💡 Oportunidades'],['todos','Todos']].map(([id,label]) => (
          <button key={id} onClick={() => setTab(id)}
            style={{ padding:'7px 16px', borderRadius:12, fontSize:12, fontWeight:700, border:'none', cursor:'pointer', fontFamily:'Plus Jakarta Sans,sans-serif',
              background: tab===id ? '#7c5ef8' : 'transparent',
              color: tab===id ? '#fff' : '#888' }}>
            {label}
            {data && id !== 'todos' && (
              <span style={{ marginLeft:6, fontSize:10, opacity:.7 }}>
                ({id==='winners' ? data.resumen?.killers : id==='criticos' ? data.resumen?.criticos : data.resumen?.regulares})
              </span>
            )}
          </button>
        ))}
      </div>

      <div style={{ background:'#fff', border:'1px solid #e8e8e0', borderRadius:18, overflow:'hidden' }}>
        {loading ? (
          <div style={{ textAlign:'center', padding:60, color:'#bbb', fontSize:13 }}>Calculando rentabilidad...</div>
        ) : (
          <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
            <thead>
              <tr style={{ borderBottom:'1px solid #f0f0e8', background:'#fafaf5' }}>
                {['Publicación','Uds','Ingresos','COGS','Comisión','Envío','Retenc.','Margen $','Margen %','Diagnóstico'].map(h => (
                  <th key={h} style={{ textAlign:'left', color:'#bbb', padding:'14px 10px', fontSize:10, fontWeight:700, textTransform:'uppercase', letterSpacing:'.4px' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan={10} style={{ textAlign:'center', padding:40, color:'#ccc', fontSize:13 }}>No hay publicaciones en esta categoría</td></tr>
              ) : filtered.map(p => {
                const dc = diagColor(p.diagnostico);
                return (
                  <tr key={p.item_id} style={{ borderBottom:'1px solid #f8f8f4' }}>
                    <td style={{ padding:'12px 10px', display:'flex', alignItems:'center', gap:8, maxWidth:240 }}>
                      {p.thumbnail ? (
                        <img src={p.thumbnail.replace('http://','https://')} alt="" style={{ width:36, height:36, borderRadius:6, objectFit:'cover', flexShrink:0 }} onError={e => e.target.style.display='none'} />
                      ) : (
                        <div style={{ width:36, height:36, borderRadius:6, background:'#f5f5ef', flexShrink:0 }}></div>
                      )}
                      <div>
                        <div style={{ color:'#1a1a1a', fontWeight:600, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', maxWidth:180 }}>{p.title || p.item_id}</div>
                        <div style={{ color:'#bbb', fontSize:10, marginTop:2 }}>{p.sku || p.item_id}</div>
                      </div>
                    </td>
                    <td style={{ padding:'12px 10px', color:'#1a1a1a', fontWeight:600 }}>{p.unidades}</td>
                    <td style={{ padding:'12px 10px', color:'#7c5ef8', fontWeight:700 }}>{fmt(p.ingresos)}</td>
                    <td style={{ padding:'12px 10px', color:'#dc2626' }}>{fmt(p.total_cogs)}</td>
                    <td style={{ padding:'12px 10px', color:'#f97316' }}>{fmt(p.comision)}</td>
                    <td style={{ padding:'12px 10px', color:'#888' }}>{fmt(p.envio)}</td>
                    <td style={{ padding:'12px 10px', color:'#bbb' }}>{fmt(p.retencion)}</td>
                    <td style={{ padding:'12px 10px', fontWeight:700, color: p.margen_s >= 0 ? '#3d7a00' : '#dc2626' }}>{fmt(p.margen_s)}</td>
                    <td style={{ padding:'12px 10px' }}>
                      <span style={{ padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:700,
                        background: p.margen_pct >= 30 ? '#e8f9d4' : p.margen_pct >= 0 ? '#fff7ed' : '#fee2e2',
                        color: p.margen_pct >= 30 ? '#3d7a00' : p.margen_pct >= 0 ? '#f97316' : '#dc2626' }}>
                        {p.margen_pct}%
                      </span>
                    </td>
                    <td style={{ padding:'12px 10px' }}>
                      <span style={{ padding:'3px 10px', borderRadius:20, fontSize:10, fontWeight:700, background:dc.bg, color:dc.color }}>
                        {diagLabel(p.diagnostico)}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
